import * as React from "react"

function App() {
    return (
    <>

        {/* Page HTML */}

        <section id='king-home'>

            <div id="deviceRotated">
                <span>
                    <img src="assets/images/deviceRotated.svg" />
                    Rota tu dispositivo.
                </span>
            </div>

            <div className='loader'>
                <span className='loader-value'>0%</span>
            </div>

            <canvas id='canvas-home'></canvas>

        </section>

    </>
    )
}

export default App
